import { useContext } from 'react';

import * as StyledFormElements from '../../../StyledForm/StyledForm.elements';
// import NotFoundPage from '../../../NotFoundPage';
import RequestCodeForm from '../RequestCodeForm';
import VerifyCodeForm from '../VerifyCodeForm';
import { AuthStateContext, AuthStep } from '../../../../utils/authFormState';
import { FormTextFieldProps } from '../../../FormTextField/FormTextField';

export interface AuthStepsProps {
  /**
   * Redirect route after verification complete.
   */
  redirect?: string;
  requestCodeButtonText?: string;
  /**
   * If this component is used as part of a sign-up (inside a <form />) or as sign-in (login form).
   */
  embed?: boolean;
  mobileTextFieldProps?: Partial<FormTextFieldProps>;
}
interface StepContentProps extends AuthStepsProps {
  step: AuthStep;
}

function StepContent({ step, redirect, requestCodeButtonText, ...props }: StepContentProps) {
  switch (step) {
    case AuthStep.VERIFY_CODE:
      return <VerifyCodeForm redirect={redirect} {...props} />;
    case AuthStep.REQUEST_CODE:
    default:
      return <RequestCodeForm requestCodeButtonText={requestCodeButtonText} {...props} />;
  }
}

/**
 * Two step management in verification flow.
 *
 * @param AuthStepsProps - Options to modify the form props
 * @returns The current Auth step.
 */
function AuthSteps(props: AuthStepsProps) {
  const { current } = useContext(AuthStateContext);

  return (
    <StyledFormElements.Section>
      <StepContent step={current.value as AuthStep} {...props} />
    </StyledFormElements.Section>
  );
}

export default AuthSteps;
